export default {
	"syntax.comment": {
		"foreground": "{theme.font.tertiary}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.comment.line": {
		"foreground": "{theme.font.tertiary}",
		"background": "",
		"fontStyle": "italic"
	},
  "syntax.comment.block.documentation": {
		"foreground": "{theme.font.secondary}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.comment.single": {
		"foreground": "{theme.font.tertiary}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.constant.language.dart": {
		"foreground": "{theme.font.code.26}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.constant.language.boolean.false": {
		"foreground": "{theme.font.code.21}",
		"background": "",
		"fontStyle": "underline bold"
	},
  "syntax.constant.language.boolean.true": {
		"foreground": "{theme.font.code.25}",
		"background": "",
		"fontStyle": "underline bold"
	},
  "syntax.constant.language.import-export-all": {
		"foreground": "{theme.font.code.27}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.constant.language.null": {
		"foreground": "{theme.font.code.21}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.constant.language.symbol": {
		"foreground": "{theme.font.code.29}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.constant.language.undefined": {
		"foreground": "{theme.font.code.21}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.constant.numeric": {
		"foreground": "{theme.font.code.29}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.entity.name.tag": {
		"foreground": "{theme.font.code.21}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.entity.name.tag.reference": {
		"foreground": "{theme.font.code.8}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.entity.name.tag.yaml": {
		"foreground": "{theme.font.code.22}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.entity.name.type.module": {
		"foreground": "{theme.font.code.22}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.entity.name.function": {
		"foreground": "{theme.font.code.27}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.entity.other.attribute-name.id": {
		"foreground": "{theme.font.code.22}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.entity.other.attribute-name.class": {
		"foreground": "{theme.font.code.23}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.entity.other.attribute-name": {
		"foreground": "{theme.font.code.27}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.invalid": {
		"foreground": "{theme.font.code.21}",
		"background": "",
		"fontStyle": "bold underline"
	},
  "syntax.keyword": {
		"foreground": "{theme.font.code.8}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.keyword.control": {
		"foreground": "{theme.font.code.8}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.keyword.control.import": {
		"foreground": "{theme.font.code.8}",
		"background": "",
		"fontStyle": "italic"
	},
  "syntax.keyword.control.from": {
		"foreground": "{theme.font.code.8}",
		"background": "",
		"fontStyle": "italic"
	},
  "syntax.keyword.control.flow": {
		"foreground": "{theme.font.code.8}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.keyword.operator": {
		"foreground": "{theme.font.primary}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.keyword.operator.logical": {
		"foreground": "{theme.font.primary}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.keyword.other.unit": {
		"foreground": "{theme.font.code.29}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.markup.bold": {
		"foreground": "{theme.font.code.28}",
		"background": "",
		"fontStyle": "bold"
	},
  "syntax.markup.italic": {
		"foreground": "{theme.font.code.27}",
		"background": "",
		"fontStyle": "italic"
	},
  "syntax.markup.fenced_code": {
		"foreground": "{theme.font.primary}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.markup.heading": {
		"foreground": "{theme.font.primary}",
		"background": "",
		"fontStyle": "bold"
	},
  "syntax.markup.quote": {
		"foreground": "{theme.font.secondary}",
		"background": "",
		"fontStyle": "italic"
	},
  "syntax.markup.underline.link": {
		"foreground": "{theme.font.code.26}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.meta.brace.round": {
		"foreground": "{theme.font.primary}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.meta.brace.square": {
		"foreground": "{theme.font.primary}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.meta.class": {
		"foreground": "{theme.font.code.22}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.meta.jsx.children": {
		"foreground": "{theme.font.primary}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.meta.object": {
		"foreground": "{theme.font.code.29}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.meta.property-name.css": {
		"foreground": "{theme.font.code.5}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.meta.property-value.css": {
		"foreground": "{theme.font.code.5}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.meta.selector": {
		"foreground": "{theme.font.code.5}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.meta.structure.dictionary": {
		"foreground": "{theme.font.code.28}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.meta.tag.attributes": {
		"foreground": "{theme.font.code.29}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.meta.type.parameters": {
		"foreground": "{theme.font.code.23}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.meta.var.expr": {
		"foreground": "{theme.font.code.8}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.punctuation.accessor": {
		"foreground": "{theme.font.primary}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.punctuation.definition.array": {
		"foreground": "{theme.font.primary}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.punctuation.definition.block": {
		"foreground": "{theme.font.primary}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.punctuation.definition.dictionary": {
		"foreground": "{theme.font.primary}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.punctuation.definition.heading": {
		"foreground": "{theme.font.code.22}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.punctuation.definition.list": {
		"foreground": "{theme.font.code.21}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.punctuation.definition.parameters": {
		"foreground": "{theme.font.primary}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.punctuation.definition.string": {
		"foreground": "{theme.font.code.25}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.punctuation.definition.tag": {
		"foreground": "{theme.font.primary}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.punctuation.definition.typeparameters": {
		"foreground": "{theme.font.primary}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.punctuation.definition.template-expression": {
		"foreground": "{theme.font.code.21}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.punctuation.section": {
		"foreground": "{theme.font.secondary}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.punctuation.separator": {
		"foreground": "{theme.font.primary}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.punctuation.terminator": {
		"foreground": "{theme.font.tertiary}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.storage": {
		"foreground": "{theme.font.code.8}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.string": {
		"foreground": "{theme.font.code.25}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.string.key": {
		"foreground": "{theme.font.code.29}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.support.class": {
		"foreground": "{theme.font.code.22}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.support.class.component": {
		"foreground": "{theme.font.code.22}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.support.constant.color": {
		"foreground": "{theme.font.code.27}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.support.constant.font-name": {
		"foreground": "{theme.font.code.27}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.support.constant.property-value": {
		"foreground": "{theme.font.code.27}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.support.function": {
		"foreground": "{theme.font.code.8}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.support.function.math": {
		"foreground": "",
		"background": "",
		"fontStyle": ""
	},
  "syntax.support.type.property-name": {
		"foreground": "{theme.font.code.26}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.support.type.property-name.css": {
		"foreground": "{theme.font.primary}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.support.type.vendored": {
		"foreground": "{theme.font.code.22}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.variable": {
		"foreground": "{theme.font.code.26}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.variable.language.super": {
		"foreground": "{theme.font.code.5}",
		"background": "",
		"fontStyle": "italic"
	},
  "syntax.variable.language.this": {
		"foreground": "{theme.font.code.3}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.variable.other": {
		"foreground": "{theme.font.code.26}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.variable.other.constant": {
		"foreground": "{theme.font.code.26}",
		"background": "",
		"fontStyle": ""
	},
  "syntax.variable.other.readwrite.alias": {
		"foreground": "{theme.font.code.26}",
		"background": "",
		"fontStyle": ""
	}
}
